import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp4-special-edition-triwizard-tournament",
  name: `The Daily Prophet\n'Special Edition Triwizard Tournament'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Special Edition Triwizard Tournament'",
  },
  origin: "Harry Potter and the Goblet of Fire",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
